import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import SkeletonFluid from '@/components/skeletonFluid/skeletonFluid'
import CommerceProduct from '@/components/commerceProduct/commerceProduct'

@Component({
  components: {
    SkeletonFluid,
    CommerceProduct
  }
})
export default class ProductsSearch extends Vue {

  @Action action_getProductsSearch
  @Getter getProductsSearch
  @Getter getCity
  @Mutation PRODUCTS_SEARCH

  loadingPage = false;
  products = [];

  get getSearchTitle() {
    if(this.$route.query && this.$route.query.search) {
      const searchValue = this.$route.query.search;
      return `Resultados para "${searchValue}"`;
    }
    return "Resultados de búsqueda";
  }

  async mounted() {
    await this.onRouteQueryChange();
  }

  @Watch('$route.query.search', { deep: true })
  async onRouteQueryChange() {
    this.loadingPage = true;
    try {
      if (this.$route.query && this.$route.query.search) {
        const searchValue = this.$route.query.search;
        const cityId = this.getCity.id;
        const payload = {
          cityId,
          searchValue
        };
        await this.action_getProductsSearch(payload);
        this.products = this.getProductsSearch.products;
      }
    } catch (error) {
      this.$swal({
        title: "Error",
        text: "¡Ups! No pudimos encontrar lo que buscabas."
      })
    }
    this.loadingPage = false;
  }

  onBackPress() {
    this.$router.go(-1);
  }
}